import * as React from "react";
import { BannerContainer } from "../../../components/BannerContainer";
import { TBannerItem } from "../../../services/banner";
import { LinkTargetType, TModuleWithImgProps } from "../../../services/playground";
import { MagicLinkBox } from "./styles";
import { Span } from "@sentry/types";

export interface TMagicItem {
	link: string;
	width: string;
	height: string;
	left: string;
	top: string;
}

export interface MMagicBannerProps extends TModuleWithImgProps {
	banner: TBannerItem;
	linkItems: TMagicItem[];
	onClick?: (link: string) => void;
	span?: Span;
}
const MMagicBanner = (props: MMagicBannerProps) => {
	const {
		banner,
		positionId,
		linkItems,
		style = { width: "100%" },
		className,
		placeholderBg,
		aTarget = LinkTargetType.Blank,
	} = props;
	const bannerHeight = banner.height || "auto";

	React.useEffect(() => {
		props?.span?.finish();
	}, []);

	return (
		<BannerContainer
			banner={banner}
			data-id={positionId}
			id={positionId}
			className={className || ""}
			keepSize={true}
			placeholderBg={placeholderBg}
			gridHeight={bannerHeight}
			style={{ ...style }}
		>
			{(linkItems || []).map((item: TMagicItem, i) => (
				<MagicLinkBox
					key={i}
					href={item.link}
					onClick={() => props.onClick && props.onClick(item.link)}
					target={item?.link.startsWith("#") ? "_self" : aTarget}
					style={{
						width: `${Math.min(100, +(item.width || 0))}%`,
						height: `${item.height}%`,
						top: `${item.top}%`,
						left: `${item.left}%`,
					}}
				/>
			))}
		</BannerContainer>
	);
};

export default MMagicBanner;
